import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { customerPaymentMethodService } from '@/services/customer/payment-method.service';
import type { CustomerPaymentMethodConfirmRequest } from '@/types/customer-payment-method';

export const customerPaymentMethodKeys = {
  all: ['customer', 'payment-method'] as const,
  current: () => [...customerPaymentMethodKeys.all, 'current'] as const,
};

export function useCustomerPaymentMethod(enabled = true) {
  return useQuery({
    queryKey: customerPaymentMethodKeys.current(),
    queryFn: () => customerPaymentMethodService.getPaymentMethod(),
    staleTime: 30_000,
    enabled,
  });
}

export function useCreateCustomerPaymentMethodSetupIntent() {
  return useMutation({
    mutationFn: () => customerPaymentMethodService.createSetupIntent(),
  });
}

export function useConfirmCustomerPaymentMethod() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CustomerPaymentMethodConfirmRequest) =>
      customerPaymentMethodService.confirmPaymentMethod(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: customerPaymentMethodKeys.all });
    },
  });
}

export function useRemoveCustomerPaymentMethod() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => customerPaymentMethodService.removePaymentMethod(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: customerPaymentMethodKeys.all });
    },
  });
}

